import styled from "styled-components";
import theme from "../../../style/theme";
import { RecentLocationContentByDeliveryDto } from "../../../types/delivery/delivery-dto";
import { convertYYYYMMDDddddFormat } from "../../../utils/date/date-format";
import { ContainedYellowButton } from "../../button/ContainedYellowButton";

interface Props {
  recentLocation: RecentLocationContentByDeliveryDto;
  handleClickSelectButton: (
    selectedRecentLocation: RecentLocationContentByDeliveryDto
  ) => void;
}

const buttonStyle = {
  fontWeight: 600,
  fontSize: "13px",
  fontHeight: "16px",
  color: theme.palette.primitives.gray800,
  padding: "0",
};

export const RecentLocationSearchItem: React.FC<Props> = ({
  recentLocation,
  handleClickSelectButton,
}) => {
  return (
    <RecentLocationSearchItemContainer>
      <HeaderContainer>
        <HeaderLeftContainer>
          {recentLocation.workPlace.alias}
        </HeaderLeftContainer>
        <HeaderRightContainer>
          {convertYYYYMMDDddddFormat(recentLocation.dateToWork)}
        </HeaderRightContainer>
      </HeaderContainer>
      <FlexContainer>
        <FlexLeftContainer>주소</FlexLeftContainer>
        <FlexRightContainer>
          {`${recentLocation.roadAddress}`}
        </FlexRightContainer>
      </FlexContainer>
      <FlexContainer>
        <FlexLeftContainer>상세주소</FlexLeftContainer>
        <FlexRightContainer>
          {`${recentLocation.workPlace.detail}`}
        </FlexRightContainer>
      </FlexContainer>
      <FlexContainer>
        <FlexLeftContainer>층</FlexLeftContainer>
        <FlexRightContainer>
          {`${recentLocation.workPlace.floor}`}
        </FlexRightContainer>
      </FlexContainer>
      <FlexContainer>
        <FlexLeftContainer>연락처</FlexLeftContainer>
        <FlexRightContainer>
          {`${recentLocation.workPlace.phone || "없음"}`}
        </FlexRightContainer>
      </FlexContainer>
      <SelectButtonContainer>
        <ContainedYellowButton
          width="72px"
          height="36px"
          text="선택"
          onClick={() => handleClickSelectButton(recentLocation)}
          sx={buttonStyle}
        />
      </SelectButtonContainer>
    </RecentLocationSearchItemContainer>
  );
};

const RecentLocationSearchItemContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding 24px 20px;
  margin-top: 12px;
  border : 0.5px solid ${theme.palette.primitives.gray300};
  border-radius: 4px;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const HeaderLeftContainer = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: ${theme.palette.primitives.gray800};
`;

const HeaderRightContainer = styled.div`
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  color: ${theme.palette.primitives.gray400};
`;

const FlexContainer = styled.div`
  display: flex;
  margin-bottom: 8px;
`;

const FlexLeftContainer = styled.div`
  width: 61px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${theme.palette.primitives.gray500};
`;

const FlexRightContainer = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${theme.palette.primitives.gray900};
`;

const SelectButtonContainer = styled.div`
  position: absolute;
  right: 20px;
  bottom: 20px;
`;
